export default "__VITE_ASSET__rBLHSMBG__"